var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"zlr-menu"},_vm._l((_vm.menuList),function(item,index){return _c('li',{key:index},[_c('a',{class:[!item.name?'zlr-menu-disabled':'',_vm.$route.matched.some(function (ref) {
	var name = ref.name;

	return item.name===name;
})?'active':''],on:{"click":function($event){return _vm.linkHandle(item.name)}}},[_vm._v(_vm._s(item.title))]),(item.children)?[_c('ul',{staticClass:"zlr-menu-child"},_vm._l((item.children),function(child,childIndex){return _c('li',{key:childIndex},[_c('a',{class:[!child.name?'zlr-menu-disabled':'',_vm.$route.matched.some(function (ref) {
	var name = ref.name;

	return child.name===name;
})?'active':''],on:{"click":function($event){return _vm.linkHandle(child.name)}}},[_vm._v(_vm._s(child.title))])])}),0)]:_vm._e()],2)}),0)}
var staticRenderFns = []

export { render, staticRenderFns }